// Generated by Claude Code
import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$companyId/analytics/')({
  component: RouteComponent,
  staticData: { appShell: true },
})

function RouteComponent() {
  const { companyId } = Route.useParams()
  return <Navigate to="/$companyId/analytics/work-orders" params={{ companyId }} replace />
}
